/** @jsxImportSource @emotion/react */

import { Typography } from "@mui/material";
import { css } from "@emotion/react";
import Divider from "@mui/material/Divider";
import Markdown from "markdown-to-jsx";
import useMediaQuery from "@mui/material/useMediaQuery";

const dividerStyle = (theme, bottomMargin, titleColor) => css`
  :before {
    border-color: ${titleColor || "white"};
  }
  :after {
    border-color: ${titleColor || "white"};
  }
  margin-bottom: ${bottomMargin};
  .MuiTypography-h5 {
    font-family: ${theme.typography.MBCORPOA} !important;
  }
`;
const typographyH6style = css`
  font-size: 14px;
  line-height: 35px;
  img {
    width: 100%;
  }
`;
const titleStyle = (theme, matches) => css`
  transform-origin: center;
  font-family: ${theme.typography.MBCORPOA};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 32px;
  line-height: 32px;
  max-width: ${matches ? "90vw" : "100vw"};
`;

export const CenteredTextWithUnderline = ({
  title,
  description,
  bottomMargin,
  titleVariant,
  titleColor,
  mobileUnderline,
}) => {
  const matches = useMediaQuery("(max-width: 415px)");
  return (
    <div>
      {matches && mobileUnderline !== "yes" ? (
        <Typography>{title}</Typography>
      ) : (
        title && (
          <Divider
            variant="h5"
            css={(theme) => dividerStyle(theme, bottomMargin, titleColor)}
          >
            <Typography
              variant={titleVariant}
              css={(theme) => titleStyle(theme, matches)}
              color={titleColor}
              title={title}
            >
              {title}
            </Typography>
          </Divider>
        )
      )}

      <Typography
        variant="h6"
        color={titleColor || "text.secondary"}
        css={typographyH6style}
      >
        <Markdown>
          {(process.env.REACT_APP_BASEURL.includes("localhost")
            ? description?.replaceAll(
                "/uploads/",
                `${process.env.REACT_APP_BASEURL}/uploads/`
              )
            : description) || ""}
        </Markdown>
      </Typography>
    </div>
  );
};
